<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "State of Charge Difference per Charging Session" chart.
    </rb-callout>
</div>
<div id="soc-delta-per-charging-procedure-ef-chart-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of charging events based on their state of charge increase. The fractions are determined from all charging phases in the whole fleet.
    </div>
</div>